module.exports = __webpack_public_path__ + "img/logoMainNav.126a4bc3.webp";